import { AuthContextProvider, OrganizationProvider } from 'contexts';
import { useAppState } from 'contexts/AppContext';
import { useTabContext } from 'contexts/TabContext';
import { Outlet, useLocation } from 'react-router-dom';
import { Button, Icon, Image, Label, Menu } from 'semantic-ui-react';

//import ConnectSidebar from 'components/connectSidebar';
const MainLayout: React.FC = () => {
  const { authState, appState, logout, isLoggingOut } = useAppState();
  const { setTab, activeAlertsCount } = useTabContext();
  const location = useLocation();

  const { token, userEmail } = authState;
  const { eligibilityGroups, gender, payers, practitionerId, practitionerName, vendors, foodCardVendors } = appState;

  // Check if we're on the main/index page
  const isMainPage = location.pathname === '/';

  const onLogout = () => {
    logout();
  };

  const changeActiveTab = () => {
    setTab(4); // Index of Alerts tab
  };

  const styles = {
    menu: {
      margin: '0',
      borderRadius: '0',
      paddingRight: '3rem',
    },
  };

  return (
    <div>
      <Menu style={styles.menu} size="small" stackable inverted>
        <Menu.Item key="image">
          <Image src="/images/nrx.jpg" />
        </Menu.Item>
        <Menu.Item key="title" name="CARE BETTY" />
        <Menu.Menu key="rightbar" position="right">
          <Menu.Item key="user name">{practitionerName}</Menu.Item>

          {isMainPage && (
            <Menu.Item key="alertsIcon" as="a" onClick={changeActiveTab} style={{ marginTop: '12px' }}>
              <Icon name="bell" />
              <Label color="red" floating circular content={activeAlertsCount} />
            </Menu.Item>
          )}

          <Menu.Item key="logout">
            <Button color="red" loading={isLoggingOut} onClick={onLogout} content="Logout" />
          </Menu.Item>
        </Menu.Menu>
      </Menu>
      <AuthContextProvider
        // These are `string | null` here but `string` on `AuthContextType`; asserted
        // rather than widened there. See the defect note in `contexts/AuthContext.tsx`.
        value={{
          token: token!,
          userEmail: userEmail!,
          practitionerId: practitionerId!,
          practitionerName: practitionerName!,
          payers: payers,
          vendors: vendors,
          foodCardVendors: foodCardVendors ?? [],
          validateUSPSAddress: true,
          eligibilityGroups: eligibilityGroups,
          gender: gender!,
        }}
      >
        <OrganizationProvider>
          {/* <ConnectSidebar> */}
            <Outlet />
          {/* </ConnectSidebar> */}
        </OrganizationProvider>
      </AuthContextProvider>
    </div>
  );
};

export default MainLayout;
